import { Card } from '../ui';
import { ConfidenceIndicator } from '../ui/ConfidenceIndicator';

type Props = {
  dimensions?: string[];
  confidence?: number;
  asin?: string;
  lastUpdated?: string;
};

export function ProductDNACard({
  dimensions = [],
  confidence = 87,
  asin = 'B0CX1234AB',
  lastUpdated = '2 hours ago',
}: Props) {
  return (
    <Card padding="sm" className="border-ai-200 bg-ai-50/20 dark:border-ai-900 dark:bg-ai-950/20">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-ai-600">Product DNA</p>
          <p className="mt-1 font-mono text-xs text-slate-500">{asin}</p>
          <p className="text-xs text-slate-500">Updated {lastUpdated}</p>
        </div>
        <ConfidenceIndicator score={confidence / 100} size="sm" />
      </div>
      {dimensions.length > 0 && (
        <div className="mt-3 grid gap-2 sm:grid-cols-2">
          {dimensions.map((d) => (
            <div key={d} className="flex items-center gap-2 rounded border border-ai-200 bg-white/60 px-2 py-1.5 text-xs dark:border-ai-800 dark:bg-slate-900/60">
              <span className="h-1.5 w-1.5 rounded-full bg-ai-500" />
              {d}
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
